var __webpack_exports__ = {};
/*!*************************************!*\
  !*** ./src/js/dawn/product-form.js ***!
  \*************************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (!customElements.get('product-form')) {
  customElements.define('product-form', /*#__PURE__*/function (_HTMLElement) {
    _inherits(ProductForm, _HTMLElement);
    var _super = _createSuper(ProductForm);
    function ProductForm() {
      var _this;
      _classCallCheck(this, ProductForm);
      _this = _super.call(this);
      _this.form = _this.querySelector('form');
      _this.form.querySelector('[name=id]').disabled = false;
      _this.form.addEventListener('submit', _this.onSubmitHandler.bind(_assertThisInitialized(_this)));
      _this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      _this.submitButton = _this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) _this.submitButton.setAttribute('aria-haspopup', 'dialog');
      _this.hideErrors = _this.dataset.hideErrors === 'true';
      _this.isAddingInCart = false;
      return _this;
    }
    _createClass(ProductForm, [{
      key: "onSubmitHandler",
      value: function onSubmitHandler(evt) {
        var _this2 = this;
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (this.isAddingInCart) {
          return;
        }
        this.isAddingInCart = true;
        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.style.pointerEvents = 'none';
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        var config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        var formData = new FormData(this.form);
        var quantity = formData.get('quantity');
        var dataForm = formData;
        if (this.form.productType && this.form.productType.value == 'Carte-cadeau') {
          quantity = 1;
        }
        formData.set('quantity', quantity);
        if (quantity > 1 && formData.get('properties[__id]')) {
          for (var i = 1; i < quantity; i++) {
            var propertiesId = formData.get('properties[__id]') + i;
            var variantId = formData.get('id');
            var issueDate = new Date().toLocaleDateString();
            this.form.insertAdjacentHTML('beforeend', '<input type="hidden" name="items[' + i + '][quantity]" value="1">');
            this.form.insertAdjacentHTML('beforeend', '<input type="hidden" name="items[' + i + '][id]" value="' + formData.get('id') + '">');
            this.form.insertAdjacentHTML('beforeend', '<input type="hidden" name="items[' + i + '][properties[__id]]" value="' + propertiesId + '">');
            this.form.insertAdjacentHTML('beforeend', '<input type="hidden" name="items[' + i + '][properties[__variant_id]]" value="' + variantId + '">');
            this.form.insertAdjacentHTML('beforeend', '<input type="hidden" name="items[' + i + '][properties[__Date]]" value="' + issueDate + '">');
          }
          var formData2 = new FormData(this.form);
          if (this.cart) {
            formData2.append('sections', this.cart.getSectionsToRender().map(function (section) {
              return section.id;
            }));
            formData2.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          dataForm = formData2;
          formData2.set('quantity', 1);
          formData2.set('properties[__variant_id]', formData.get('id'));
          formData2.set('properties[__Date]', new Date().toLocaleDateString());
          config.body = formData2;
        } else {
          if (formData.get('properties[__id]')) {
            formData.set('properties[__id]', Math.floor(Date.now() / 1000));
            formData.set('properties[__variant_id]', formData.get('id'));
            formData.set('properties[__Date]', new Date().toLocaleDateString());
          }
          if (this.cart) {
            formData.append('sections', this.cart.getSectionsToRender().map(function (section) {
              return section.id;
            }));
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
        }
        fetch("".concat(routes.cart_add_url), config).then(function (response) {
          return response.json();
        }).then(function (response) {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: dataForm.get('id'),
              errors: response.description,
              message: response.message
            });
            _this2.handleErrorMessage(response.description);
            var soldOutMessage = _this2.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            _this2.submitButton.setAttribute('aria-disabled', true);
            _this2.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            _this2.error = true;
            return;
          } else if (!_this2.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if (!_this2.error) publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: dataForm.get('id')
          });
          _this2.error = false;
          var quickAddModal = _this2.closest('quick-add-modal');

          // Check if the button is from the complementary card
          var isComplementaryCardButton = evt.target.classList.contains('complementary');
          if (isComplementaryCardButton) {
            var messageElement = _this2.querySelector('.add-to-cart-msg');
            messageElement.style.height = 'auto';
            messageElement.style.opacity = '1';
            setTimeout(function () {
              messageElement.style.opacity = '0';
            }, 3000);
            messageElement.style.height = '0';
          }
          if (quickAddModal && !isComplementaryCardButton) {
            document.body.addEventListener('modalClosed', function () {
              setTimeout(function () {
                _this2.cart.renderContents(response);
              });
            }, {
              once: true
            });
            quickAddModal.hide(true);
          } else {
            _this2.cart.renderContents(response);
          }
        }).catch(function (e) {
          console.error(e);
        }).finally(function () {
          setTimeout(function () {
            if (_this2.cart && _this2.cart.classList.contains('is-empty')) _this2.cart.classList.remove('is-empty');
            if (!_this2.error) _this2.submitButton.removeAttribute('aria-disabled');
            _this2.querySelector('.loading-overlay__spinner').classList.add('hidden');
            _this2.submitButton.classList.remove('loading');
            _this2.isAddingInCart = false;
            _this2.submitButton.style.pointerEvents = 'all';
          }, 500);
        });
      }
    }, {
      key: "handleErrorMessage",
      value: function handleErrorMessage() {
        var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }]);
    return ProductForm;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement)));
}
